import { useState } from "react";
import { useTheme } from "@mui/material";
import { RichTextarea } from "rich-textarea";
import { useChatContext } from "../chat-context";
import { getRenderer } from "../../word-suggestion";

type ChatTextInputProps = {
  isLoading: boolean;
};

const ChatTextInput = ({ isLoading }: ChatTextInputProps) => {
  const {
    input,
    inputKeywords,
    handleSend,
    suggestions,
    handleSuggestionClick,
    handleUserInputChange,
    feToTypeDict,
  } = useChatContext();

  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);
  const renderer = getRenderer(inputKeywords, feToTypeDict);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !isLoading) {
      if (e.shiftKey) {
        // Allow Shift + Enter to add a new line
        // Default action, do nothing extra here
      } else {
        e.preventDefault();
        handleSend(false);
      }
    } else if (e.key === "Tab" && suggestions.length > 0) {
      e.preventDefault();
      handleSuggestionClick(suggestions[0]);
    }
  };

  return (
    <>
      <RichTextarea
        value={input}
        onChange={handleUserInputChange}
        onKeyDown={handleKeyDown}
        style={{
          width: "97%",
          padding: "0.5rem",
          borderRadius: "5px",
          border: `0.5px solid ${
            isFocused ? theme.palette.primary.main : "#ccc"
          }`,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.body1.fontSize,
          lineHeight: theme.typography.body1.lineHeight,
          outline: "none",
          transition: "border-color 0.2s",
          resize: "none",
          overflow: "auto",
        }}
        onFocus={() => setIsFocused(true)} // Set focus state
        onBlur={() => setIsFocused(false)} // Reset focus state
        rows={2}
      >
        {renderer}
      </RichTextarea>
      <style>
        {`
          /* Custom Scrollbar Styling */
          ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }

          ::-webkit-scrollbar-thumb {
            background-color: ${theme.palette.secondary.light};
            border-radius: 10px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background-color: ${theme.palette.secondary.main};
          }

          ::-webkit-scrollbar-track {
            background-color: #f1f1f1;
            border-radius: 10px;
          }

          /* Firefox scrollbar */
          scrollbar-width: thin;
        `}
      </style>
    </>
  );
};

export default ChatTextInput;
